import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf4efa76"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "createPost",
  tabindex: "-1",
  "aria-labelledby": "createPost",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title text-center fw-bold w-100",
  id: "staticBackdropLabel"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "fw-bold col-form-label me-2" }
const _hoisted_12 = { class: "text-danger fs-7" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "fw-bold col-form-label me-2" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = { class: "text-danger fs-7" }
const _hoisted_21 = { class: "position-relative mb-2" }
const _hoisted_22 = ["placeholder", "onKeyup"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_26 = {
  key: 0,
  class: "text-danger fs-7"
}
const _hoisted_27 = { class: "mb-0 fw-bold fs-7" }
const _hoisted_28 = {
  key: 1,
  class: "mb-0 fw-bold fs-7 text-danger"
}
const _hoisted_29 = {
  key: 2,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_30 = {
  key: 3,
  class: "d-flex justify-content-center m-2"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-1" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 2,
  class: "me-1 text-truncate"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 4,
  class: "invalid-error mar-bot-15"
}
const _hoisted_39 = {
  key: 1,
  class: "invalid-error mar-bot-15"
}
const _hoisted_40 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "fw-bold col-form-label me-2" }
const _hoisted_43 = { class: "mt-2 d-flex align-items-center justify-content-between" }
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = { class: "fw-bold col-form-label me-2" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 2,
  class: "invalid-error"
}
const _hoisted_48 = {
  key: 3,
  class: "text-danger fs-7"
}
const _hoisted_49 = {
  key: 4,
  class: "invalid-feedback d-block"
}
const _hoisted_50 = {
  key: 5,
  class: "invalid-feedback d-block"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fw-bold fs-7" }, " ※文字の入力を確定するとタグとして追加されます。 ", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fw-bold fs-7" }, " ※タグは1つの投稿に5つまで設定できます。 ", -1))
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-lg-6 d-lg-flex d-none justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_55 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-lg-0 mb-4" }
const _hoisted_56 = { class: "col-lg-6 d-flex d-lg-none justify-content-lg-end justify-content-center mb-lg-0" }
const _hoisted_57 = {
  class: "modal fade",
  id: "createPostDone",
  tabindex: "-1",
  "aria-labelledby": "createPostDone",
  "aria-hidden": "true"
}
const _hoisted_58 = { class: "modal-dialog" }
const _hoisted_59 = { class: "modal-content" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end p-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_61 = { class: "modal-body text-center" }
const _hoisted_62 = { class: "mb-4 d-flex justify-content-center" }

import HashTag from '@/components/hash-tag/index.vue'
import Button from '@/components/button/index.vue'
import ArticleGroup from './ArticleGroup.vue'
import { computed, ref, watch, onMounted, nextTick } from 'vue'
import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Status from '@/components/status/index.vue'
import { debounce, isEmpty, uniqBy } from 'lodash'
import { Modal } from 'bootstrap'

//validate
import useVuelidate, { Validation } from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import { DEFAULT_MIN_LENGTH, MAX_UPLOAD_FILE_SIZE_MB, MAX_UPLOAD_FILE_SIZE_BYTES, MAX_LENGTH_POST_CONTENT } from '@/constants/number'

import { pick, omit } from 'lodash'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { POST_STORE, COMMUNITY_STORE } from '@/store/constants'
import { NewPost } from '@/services/post.services'
import { buildFormData, buildImgUrl, countCharInSurrogatePair, customMaxLength, customMinLength, handleBlurInput, scrollToErrors } from '@/utils'

import { imgTypes } from '@/constants/upload-type'
import { REGEX_EMOJI } from '@/constants/regex'
import commonService from '@/services/common.service'
import { postMessageByCode } from '@/constants/messageCode.ts'
import { CommunityStateTypes } from '@/store/modules/community'
import { validateUrlRulesSF10, VALIDATOR_CONTAIN_NG_WORD } from '@/constants/validate'
import UrlInput from '@/components/post-url/UrlInput.vue'

type TAG = { id: number; name: string }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const modalCreate = ref()
const modalNotification = ref()
const inputRef = ref<HTMLElement | null>(null)

const uploadImgStatus = ref<boolean>(false)

const file = ref(null)
const fileData = ref(null)
const fileUrl = ref(null)
const fileName = ref<string>(null)
const fileType = ref<string>(null)
const ngWords = ref({
  ngTitle: false,
  ngContent: false,
  ngTag: false,
})
/**
 * Combine with existed validation from v$ rules
 * update value after field blurred.
 */
const $externalResults = ref()

const isCheckedNGWord = { title: false, content: false, tag: false }
const MAX_LENGTH_TITLE = 30
const MAX_LENGTH_TEXT = MAX_LENGTH_POST_CONTENT

const loading = ref<boolean>(false)
const contentTypeChange = ref<boolean>(false)
const profileCommunity = computed<CommunityStateTypes>(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])
const content_type = ref<Pick<NewPost, 'content_type'>>(1)

onMounted(() => {
  modalCreate.value = new Modal(document.getElementById('createPost'))
})
onMounted(() => {
  modalNotification.value = new Modal(document.getElementById('createPostDone'))
})

const tags = ref<Array<any>>([])

const tag = ref<Pick<TAG, 'title'>>('')

const store = useStore()

const errorUpload = ref(false)
const MaxUploadFileSize = ref(false)
const create_post_status = computed(() => store.getters[POST_STORE.GETTERS.CREATE_POST_STATUS])

// 2022/09/20 CW-TrungNT Fix uat#4415: SF10
const postFailedMessageCode = computed(() => store.getters[POST_STORE.GETTERS.POST_FAILED_MESSAGE_CODE])
const emojiTag = ref<boolean>(false)
const duplicateTags = ref<boolean>(false)

const setContentType = (contentType: number): void => {
  contentTypeChange.value = true
  content_type.value = contentType
}

const checkTags = ref<boolean>(false)
const checkNgTags = async (): Promise<void> => {
  if (tags.value.length === 0) {
    checkTags.value = false
    emojiTag.value = false
    return
  }
  const tagData = tags.value.map((e: TAG) => e.name).join(', ')
  try {
    // REGEX_EMOJIは絵文字を含まない場合にTrueとなるので反転する
    emojiTag.value = !REGEX_EMOJI.test(tagData)
    if (!emojiTag.value) {
      const data = await commonService.sendNGWordCheck({ sentence: tagData })
      checkTags.value = data.data.data.has_ngword
    }
  } catch (error) {
    console.log(error)
  }
}

const createTag = async (): Promise<void> => {
  if (!tag.value || tags.value.length === 5) return
  isCheckedNGWord.tag = false
  await checkNGKeyTag(tag.value)
  while (!isCheckedNGWord.tag) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (emojiTag.value) return
  if (ngWords.value.ngTag) return

  const trimmedArray = tag.value.replace(/\s+/g, ' ').split(' ')
  trimmedArray.forEach((elem: string) => {
    for (let i = 0; i < elem.length; i = i + 20) {
      if (tags.value?.length === 5) break
      let trimmedString = elem.substring(i, i + 20)

      tags.value.push({
        id: `new-${Date.now()}${tags.value?.length}`,
        name: trimmedString,
      })
    }
  })

  tag.value = ''
  if (tags.value?.length < 5) {
    inputRef.value?.focus()
  }
}

const removeTag = async (id: number): Promise<void> => {
  tags.value = tags.value.filter((e: TAG) => e.id !== id)
  await checkNgTags()
}

const editTag = async (id: number, name: string): Promise<void> => {
  const trimmedArray = name.replace(/\s+/g, ' ').split(' ')
  trimmedArray.forEach((elem: string, index: number) => {
    for (let i = 0; i < elem.length; i = i + 20) {
      if ((index || (!index && i)) && tags.value?.length === 5) break
      let trimmedString = elem.substring(i, i + 20)

      if (!index && !i) {
        tags.value = tags.value.map((e: TAG) => ({
          ...e,
          name: e.id === id ? trimmedString : e.name,
        }))
      } else {
        tags.value.push({
          id: `new-${Date.now()}${tags.value?.length}`,
          name: trimmedString,
        })
      }
    }
  })
  await checkNgTags()
}

const rules = computed(() => {
  return {
    title: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_TITLE),
      minLength: minLength(DEFAULT_MIN_LENGTH),
    },
    content: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_TEXT),
      minLength: (value: string) => customMinLength(value, DEFAULT_MIN_LENGTH),
    },
    site_name_1: {},
    site_url_1: {},
    site_name_2: {},
    site_url_2: {},
    ...validateUrlRulesSF10('site_name_1', 'site_url_1', formData),
    ...validateUrlRulesSF10('site_name_2', 'site_url_2', formData),
  }
})

const formData = ref({
  title: '',
  content: '',
  file: '',
  site_name_1: '',
  site_url_1: '',
  site_name_2: '',
  site_url_2: '',
})
const length_content = ref(0)
const textCounter = (maxLength: number, currentLength: number): number => {
  return maxLength - currentLength
}

const removeAvatar = (): void => {
  formData.value.file = null
  file.value = null
  fileData.value = null
  fileUrl.value = null
  fileName.value = null
  fileType.value = null
}

const handleChangeFile = async () => {
  uploadImgStatus.value = true
  if (file.value.files[0]) {
    const { newFileUrl, newFile } = await buildImgUrl(file.value.files[0])
    uploadImgStatus.value = false
    fileUrl.value = newFileUrl

    fileData.value = newFile

    fileType.value = newFile?.type
    fileName.value = newFile?.name
    formData.value.file = file.value.files[0]
  }
  uploadImgStatus.value = false
}

watch(
  () => fileType.value,
  () => {
    if (['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(fileType.value) || fileType.value === null) {
      if (formData.value.content && formData.value.title) {
        v$.value.$invalid = false
      }
      errorUpload.value = false
    } else {
      v$.value.$invalid = true
      errorUpload.value = true
    }
  }
)

watch(
  () => formData.value?.file,
  () => {
    if (formData.value?.file && formData.value?.file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
      MaxUploadFileSize.value = true
    } else {
      MaxUploadFileSize.value = false
    }
  }
)

// 2022/09/21 CW-TrungNT Fix for UAT#4415: SF10 (Ph2-R20220922)
watch(
  () => tags.value,
  () => {
    if (uniqBy(tags.value, 'name').length !== tags.value.length) {
      duplicateTags.value = true
    } else {
      duplicateTags.value = false
    }
  },
  { immediate: true, deep: true }
)

const v$ = useVuelidate(rules, formData, { $externalResults })

const onSubmit = async (): Promise<void> => {
  let content_type_value = content_type.value
  if (!profileCommunity.value?.post_article_permission && profileCommunity.value?.post_recruitment_permission && !contentTypeChange.value) {
    content_type_value = 2
  }
  v$.value.$touch()
  loading.value = true

  isCheckedNGWord.title = false
  isCheckedNGWord.content = false
  await checkNGKeyTitle()
  await checkNGKeyContent()
  if (formData.value.site_name_1) await validateUrlNgWord('site_name_1')
  if (formData.value.site_name_2) await validateUrlNgWord('site_name_2')
  while (!isCheckedNGWord.title || !isCheckedNGWord.content) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (
    v$.value.$invalid ||
    ngWords.value.ngTitle ||
    ngWords.value.ngTag ||
    ngWords.value.ngContent ||
    MaxUploadFileSize.value ||
    errorUpload.value ||
    checkTags.value ||
    emojiTag.value ||
    duplicateTags.value
  ) {
    loading.value = false
    nextTick(() => {
      const elementErrors = document.querySelector('#createPost .invalid-feedback')
      const classErrors = elementErrors ? '.invalid-feedback' : '.invalid-error'
      scrollToErrors(classErrors, '#createPost')
    })
    return
  }
  const newPostJson: NewPost = {
    ...omit(formData.value, 'file'),
    content_type: content_type_value,
    tags: tags.value.map((e: TAG) => pick(e, 'name')),
  }

  const newPost = new FormData()

  buildFormData(newPost, newPostJson)

  if (fileData.value) {
    newPost.append(imgTypes.includes(fileType.value) ? 'image' : 'file', fileData.value)
  }
  await store.dispatch(POST_STORE.ACTIONS.CREATE_POST, { newPost: newPost, community_id: route.params.id })
  loading.value = false
  modalNotification.value?.show()

  modalCreate.value?.hide()
  resetForm()
}

const onInputURL = () => {
  v$.value.site_name_1.$touch()
  v$.value.site_url_1.$touch()
  v$.value.site_name_2.$touch()
  v$.value.site_url_2.$touch()
}

const resetForm = (): void => {
  v$.value.$reset()
  formData.value = { title: '', content: '', site_name_1: '', site_url_1: '', site_name_2: '', site_url_2: '', file: '' }
  ngWords.value = { ngTitle: false, ngContent: false, ngTag: false }
  tag.value = ''
  tags.value = []
  file.value = null
  fileUrl.value = null
  fileName.value = null
  fileType.value = null
  content_type.value = 1
  fileData.value = null
  emojiTag.value = false
  checkTags.value = false
}
onMounted(() => {
  window.addEventListener('hidden.bs.modal', function () {
    resetForm()
  })
})

const checkNGKeyTitle = debounce(async () => {
  const queryData = { sentence: formData.value.title }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWords.value.ngTitle = data.data.data.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGWord.title = true
  }
})

const checkNGKeyContent = debounce(async () => {
  const queryData = { sentence: formData.value.content }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWords.value.ngContent = data.data.data.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGWord.content = true
  }
})

const checkNGKeyTag = debounce(async (value: string) => {
  if (!value || tags.value.length === 5) {
    emojiTag.value = false
    ngWords.value.ngTag = false
    isCheckedNGWord.tag = true
    return
  }
  const queryData = { sentence: value }
  try {
    // REGEX_EMOJIは絵文字を含まない場合にTrueとなるので反転する
    emojiTag.value = !REGEX_EMOJI.test(value)
    if (!emojiTag.value) {
      const data = await commonService.sendNGWordCheck(queryData)
      ngWords.value.ngTag = data.data.data.has_ngword
    } else {
      ngWords.value.ngTag = false
    }
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGWord.tag = true
  }
})

watch(
  () => tag.value,
  (newVal: any) => {
    checkNGKeyTag(newVal as string)
  }
)

const CheckLength = () => {
  length_content.value++
}

const focusInputTag = () => {
  if (tags.value.length === 5) return

  inputRef.value?.focus()
}

const validateUrlNgWord = async (name: string) => {
  const queryData = { sentence: formData.value[name] }
  const data = await commonService.sendNGWordCheck(queryData)
  const { has_ngword: isNotValid } = data.data.data

  $externalResults.value = { ...$externalResults.value, [name]: isNotValid ? [VALIDATOR_CONTAIN_NG_WORD] : [] }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('createPost')), 1),
            _hoisted_6
          ]),
          _createElementVNode("form", {
            onSubmit: _withModifiers(onSubmit, ["prevent"]),
            class: "modal-body p-3 pb-4 pb-lg-5 w-100 mx-lg-auto mx-1"
          }, [
            _createVNode(ArticleGroup, {
              onSetContentType: setContentType,
              content_type: content_type.value
            }, null, 8, ["content_type"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)(`title`)), 1),
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(textCounter(MAX_LENGTH_TITLE, _unref(countCharInSurrogatePair)(formData.value.title))), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "title",
                class: _normalizeClass(['form-control mb-2', _unref(v$).title.$error || ngWords.value.ngTitle ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).title.$model) = $event)),
                placeholder: _unref(translate)('SD10requireTitle'),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(checkNGKeyTitle)()))
              }, null, 42, _hoisted_13), [
                [
                  _vModelText,
                  _unref(v$).title.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngWords.value.ngTitle && !_unref(v$).title.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: 'title',
                validator: _unref(v$).title.$errors[0]?.$validator,
                params: [_unref(DEFAULT_MIN_LENGTH), MAX_LENGTH_TITLE]
              }, null, 8, ["validator", "params"]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)(`content`)), 1),
                    _hoisted_19,
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(textCounter(_unref(MAX_LENGTH_TEXT), _unref(countCharInSurrogatePair)(formData.value?.content))), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "content",
                    rows: "5",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                    onBlur: _cache[3] || (_cache[3] = () => (_unref(v$).content.$model = _unref(v$).content.$model.replace(/\n+$/, ''))),
                    class: _normalizeClass(['form-control ', _unref(v$).content.$error || ngWords.value.ngContent ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('SD10requireText'),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_unref(checkNGKeyContent)())),
                    onKeyup: _withKeys(CheckLength, ["enter"])
                  }, null, 42, _hoisted_22), [
                    [_vModelText, _unref(v$).content.$model]
                  ]),
                  _createElementVNode("label", {
                    class: _normalizeClass(['camera position-absolute cursor-pointer', _unref(v$).content.$error ? 'camera--err' : '']),
                    for: "img"
                  }, _hoisted_24, 2),
                  _createElementVNode("input", {
                    type: "file",
                    class: "d-none",
                    id: "img",
                    name: "file",
                    accept: "image/png, image/jpeg, image/jpg, application/pdf",
                    onClick: _cache[5] || (_cache[5] = 
                    (event) => {
                      event.target.value = null
                    }
                  ),
                    ref: (_value, _refs) => {
                      _refs['file'] = _value
                      file.value = _value
                    },
                    onChange: handleChangeFile
                  }, null, 544),
                  (_ctx.ngKeyContent && !_unref(v$).content.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(InputErrorMessage, {
                    title: 'content',
                    validator: _unref(v$).content.$errors[0]?.$validator,
                    params: [_unref(DEFAULT_MIN_LENGTH), _unref(MAX_LENGTH_TEXT)]
                  }, null, 8, ["validator", "params"])
                ]),
                (ngWords.value.ngContent && !_unref(v$).content.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(translate)('postImageAnnotation1')), 1),
                (content_type.value === 2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_28, "※「興味あり」を押してくれた人とチャットができるようになります。"))
                  : _createCommentVNode("", true),
                (uploadImgStatus.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                  : _createCommentVNode("", true),
                (fileName.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      (!fileType.value.includes('image'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                        : _createCommentVNode("", true),
                      (fileType.value.includes('image'))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: fileUrl.value,
                            alt: "image",
                            class: "me-1 object-fit-contain mw-100"
                          }, null, 8, _hoisted_34))
                        : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(fileName.value), 1)),
                      _createElementVNode("div", {
                        class: "close-icon cursor-pointer",
                        onClick: removeAvatar
                      }, _hoisted_37)
                    ]))
                  : _createCommentVNode("", true),
                (MaxUploadFileSize.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(translate)('validateFileSize', '', [_unref(MAX_UPLOAD_FILE_SIZE_MB)])), 1))
                  : _createCommentVNode("", true)
              ]),
              (errorUpload.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(translate)('errorFileUpload')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("label", _hoisted_42, _toDisplayString(_unref(translate)(`CT10url`)), 1)
                ])
              ]),
              _createVNode(UrlInput, {
                onInput: onInputURL,
                "site-name-id": "site_name_1",
                "site-url-id": "site_url_1",
                "on-field-blur": validateUrlNgWord,
                "site-url": _unref(v$).site_url_1,
                "site-name": _unref(v$).site_name_1,
                "site-name-label": _unref(translate)('CT10siteName1'),
                "site-name-validate-msg": _unref(translate)('required1'),
                "site-url-label": _unref(translate)('CT10siteUrl1')
              }, null, 8, ["site-url", "site-name", "site-name-label", "site-name-validate-msg", "site-url-label"]),
              _createVNode(UrlInput, {
                onInput: onInputURL,
                class: "mt-4",
                "site-name-id": "site_name_2",
                "site-url-id": "site_url_2",
                "on-field-blur": validateUrlNgWord,
                "site-url": _unref(v$).site_url_2,
                "site-name": _unref(v$).site_name_2,
                "site-name-label": _unref(translate)('CT10siteName2'),
                "site-name-validate-msg": _unref(translate)('required1'),
                "site-url-label": _unref(translate)('CT10siteUrl2')
              }, null, 8, ["site-url", "site-name", "site-name-label", "site-name-validate-msg", "site-url-label"]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(translate)(`CT10tag`)), 1)
                ])
              ]),
              _createElementVNode("label", {
                class: "d-flex flex-wrap form-control mb-2",
                onClick: _withModifiers(focusInputTag, ["self"])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                  return (_openBlock(), _createBlock(HashTag, {
                    tag: tag,
                    key: tag.id,
                    class: "me-2 mb-2",
                    removeTag: () => removeTag(tag.id),
                    onEditTag: editTag,
                    editable: true
                  }, null, 8, ["tag", "removeTag"]))
                }), 128)),
                (tags.value.length < 5)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      ref: (_value, _refs) => {
                        _refs['inputRef'] = _value
                        inputRef.value = _value
                      },
                      type: "text",
                      class: "border-0 input-tag",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tag).value = $event)),
                      onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => ($event.target.blur()), ["enter"])),
                      onInput: _cache[8] || (_cache[8] = (eve) => _unref(handleBlurInput)(eve, inputRef.value)),
                      onBlur: createTag
                    }, null, 544)), [
                      [
                        _vModelText,
                        tag.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ], 8, _hoisted_46),
              (emojiTag.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_unref(translate)('validateEmoji')), 1))
                : (ngWords.value.ngTag || checkTags.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : (duplicateTags.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref(translate)('VALIDATE_SAME_TAGS')), 1))
                    : _createCommentVNode("", true),
              (tags.value.length > 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, " ※タグは1つの投稿に5つまで設定できます。 "))
                : _createCommentVNode("", true),
              _hoisted_51,
              _hoisted_52
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  class: "m-w-unset fw-bold",
                  type: 'secondary',
                  "data-bs-dismiss": 'modal',
                  onClick: resetForm
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createVNode(Button, {
                  onClick: onSubmit,
                  disabled: 
                  _unref(v$).$invalid || emojiTag.value || checkTags.value || ngWords.value.ngTitle || ngWords.value.ngTag || ngWords.value.ngContent || MaxUploadFileSize.value || loading.value || errorUpload.value || duplicateTags.value
                ,
                  title: _unref(translate)('postSubmit'),
                  class: "m-w-unset fw-bold",
                  type: 'primary',
                  loading: loading.value
                }, null, 8, ["disabled", "title", "loading"])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  class: "m-w-unset fw-bold",
                  type: 'secondary',
                  dataBsToggle: 'modal'
                }, null, 8, ["title"])
              ])
            ])
          ], 40, _hoisted_7)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _hoisted_60,
          _createElementVNode("div", _hoisted_61, _toDisplayString(_unref(create_post_status) ? _unref(postMessageByCode)(_unref(postFailedMessageCode)) || _unref(translate)('createPostFailed') : _unref(translate)('createPostSuccess')), 1),
          _createElementVNode("div", _hoisted_62, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": 'modal'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})